import React from "react";
import "../post.css";
import DayThree from "../images/day_three.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Three</h2>
        <img className="image" alt="itinerary" src={DayThree} />
        <div className="infobar">
          <div className="info">22 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Ueno. Nature park and a zoo. The National Museum of Nature and Science
          is full Japanese.
        </p>
        <h3>Evening</h3>
        <p>
          Akihabara is a boys' town. Technology and electronics. Shops sell new
          and second hand tech items. Filled with Anime and maid cafes. Gaming
          stores are multiple stories high patronised with people trying to win
          something.
        </p>
        <h3>Night</h3>
        <p>
          Tokyo Station. Walk around the modern city of Tokyo. Unlike most
          cities, the tall buildings have no logos to mark company territories.
        </p>
      </div>
    );
  }
}
